'use strict';

import { BaseController } from '../../../base/controller';

export class AcceptableAccordionSectionController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  toggleChecked($event) {
    $event.stopPropagation();
    this.isChecked = !this.isChecked;
  }

  get showFormButtons() {
    return this.status !== 'transferred';
  }

  transfer() {
    this.onChangeStatus({ item: this.item, newStatus: 'transferred' });
  }

  submit() {
    // Check section and close it
    this.isChecked = true;
    this.isOpen = false;
  }

  skip() {
    this.isSkipped = true;
  }
}
